<div #target [ngStyle]="{
display: 'hidden',
scrollMarginTop: getHeaderPixel()
}"></div>
<helsana-absence-cost-calculator-main
  [sectors]="sectors"
  [language]="props().language"
  [linkTitle]="props().linkTitle"
  [contactLink]="props().externalizeLinkUrl"
  [target]="props().target"
  [indirectCostFactor]="props().indirectCosts"
  [plannedWorkTime]="props().plannedWorkingTime"
  [potentialSaving]="props().potentialSaving"
  (submitForm)="onSubmitForm(target)"
></helsana-absence-cost-calculator-main>
